module.exports = __webpack_public_path__ + "static/media/Item_Weapon_VSS_C.cc1de671.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/item/Weapon/Main/Item_Weapon_VSS_C.png
// module id = 247
// module chunks = 0